<template>
  <h4 class="edume-section-heading">
    {{ heading }}
  </h4>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.edume-section-heading {
  margin: 0px 0px 6px;
  color: #5e5f61;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}
</style>
